import { render, staticRenderFns } from "./HistoricalGroupFilter.vue?vue&type=template&id=30b0bb8e&scoped=true&"
import script from "./HistoricalGroupFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b0bb8e",
  null
  
)

export default component.exports